import { ref, computed } from 'vue';

// Un contador para rastrear cuántos modales están abiertos
const openModalCount = ref(0);

// Una función para registrar que un modal se ha abierto
export const registerModal = () => {
  openModalCount.value++;
};

// Una función para registrar que un modal se ha cerrado
export const unregisterModal = () => {
  if (openModalCount.value > 0) {
    openModalCount.value--;
  }
};

// Un booleano computado para saber si hay algún modal abierto
export const isModalOpen = computed(() => openModalCount.value > 0);